import { createFeatureSelector, createSelector } from '@ngrx/store';

import * as fromStaticDataReducer from '../reducers';
import * as staticDataCountriesReducer from '../reducers/index';
import * as staticDataReducer from '../static-data.reducer';

//#region Static Data ROOT STATE
export const getAuthState = createFeatureSelector<staticDataReducer.State, staticDataReducer.StaticDataState>(
  staticDataReducer.staticDataFeatureKey
);
//#endregion

export const getStaticDataProductSubTypesByTypeState = createSelector(
  getAuthState,
  state => state[fromStaticDataReducer.fromStaticDataProductSubTypeByTypeReducer.productSubTypesByTypeFeatureKey]
);

export const getStaticDataProductSubTypesByTypeFailure = createSelector(
  getStaticDataProductSubTypesByTypeState,
  staticDataCountriesReducer.fromStaticDataProductSubTypeByTypeReducer.getProductSubTypesByTypeFailure
);

export const getStaticDataProductSubTypesByTypeResponse = createSelector(
  getStaticDataProductSubTypesByTypeState,
  staticDataCountriesReducer.fromStaticDataProductSubTypeByTypeReducer.getProductSubTypesByTypeResponse
);

export const getStaticDataProductSubTypesByTypeIsLoaded = createSelector(
  getStaticDataProductSubTypesByTypeState,
  staticDataCountriesReducer.fromStaticDataProductSubTypeByTypeReducer.getProductSubTypesByTypeIsLoaded
);
